module.exports = "/images/marking-icon-custom_new.svg?099fe4959ff670a33570b7f4917a742d";